import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var MiddleAlignmentIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14.126C2 13.5041 2.50083 13 3.11864 13H44.8814C45.4992 13 46 13.5041 46 14.126C46 14.7479 45.4992 15.2521 44.8814 15.2521H3.11864C2.50083 15.2521 2 14.7479 2 14.126Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 23.75C2 23.1281 2.50083 22.624 3.11864 22.624H44.8814C45.4992 22.624 46 23.1281 46 23.75C46 24.3719 45.4992 24.876 44.8814 24.876H3.11864C2.50083 24.876 2 24.3719 2 23.75Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 33.374C2 32.7521 2.50083 32.2479 3.11864 32.2479H23.1946C23.8124 32.2479 24.3132 32.7521 24.3132 33.374C24.3132 33.9959 23.8124 34.5 23.1946 34.5H3.11864C2.50083 34.5 2 33.9959 2 33.374Z"
  }));
});
MiddleAlignmentIcon.displayName = 'MiddleAlignmentIcon';
MiddleAlignmentIcon.defaultProps = {
  'aria-label': 'MiddleAlignment'
};
export default MiddleAlignmentIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/MiddleAlignmentIcon/index.js
// module id = 1896
// module chunks = 12